export const reportsBehindOrdersConstants = {
  GET_REPORTS_BEHIND_ORDERS_REQUEST: "GET_REPORTS_BEHIND_ORDERS_REQUEST",
  GET_REPORTS_BEHIND_ORDERS_SUCCESS: "GET_REPORTS_BEHIND_ORDERS_SUCCESS",
  GET_REPORTS_BEHIND_ORDERS_FAILURE: "GET_REPORTS_BEHIND_ORDERS_FAILURE",

  GET_REPORTS_BEHIND_ORDER_RULES_REQUEST: "GET_REPORTS_BEHIND_ORDER_RULES_REQUEST",
  GET_REPORTS_BEHIND_ORDER_RULES_SUCCESS: "GET_REPORTS_BEHIND_ORDER_RULES_SUCCESS",
  GET_REPORTS_BEHIND_ORDER_RULES_FAILURE: "GET_REPORTS_BEHIND_ORDER_RULES_FAILURE",

  POST_REPORTS_BEHIND_ORDER_RULES_REQUEST: "POST_REPORTS_BEHIND_ORDER_RULES_REQUEST",
  POST_REPORTS_BEHIND_ORDER_RULES_SUCCESS: "POST_REPORTS_BEHIND_ORDER_RULES_SUCCESS",
  POST_REPORTS_BEHIND_ORDER_RULES_FAILURE: "POST_REPORTS_BEHIND_ORDER_RULES_FAILURE",

  DELETE_REPORTS_BEHIND_ORDER_RULES_REQUEST: "DELETE_REPORTS_BEHIND_ORDER_RULES_REQUEST",
  DELETE_REPORTS_BEHIND_ORDER_RULES_SUCCESS: "DELETE_REPORTS_BEHIND_ORDER_RULES_SUCCESS",
  DELETE_REPORTS_BEHIND_ORDER_RULES_FAILURE: "DELETE_REPORTS_BEHIND_ORDER_RULES_FAILURE",
};
